export default __webpack_public_path__ + "static/jondan-a8788348801b3707a70e8db786eaa32f.jpg";